import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const shopCardDefaultVariants = {}
const shopCardCompoundVariants = []

const shopCardSlotNames = [
  [
    "root",
    "shop-card__root"
  ],
  [
    "topContent",
    "shop-card__topContent"
  ],
  [
    "metaWrapper",
    "shop-card__metaWrapper"
  ],
  [
    "infoWrapper",
    "shop-card__infoWrapper"
  ],
  [
    "contentWrapper",
    "shop-card__contentWrapper"
  ],
  [
    "bottomContent",
    "shop-card__bottomContent"
  ],
  [
    "title",
    "shop-card__title"
  ],
  [
    "disabled",
    "shop-card__disabled"
  ]
]
const shopCardSlotFns = /* @__PURE__ */ shopCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, shopCardDefaultVariants, getSlotCompoundVariant(shopCardCompoundVariants, slotName))])

const shopCardFn = memo((props = {}) => {
  return Object.fromEntries(shopCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const shopCardVariantKeys = []
const getVariantProps = (variants) => ({ ...shopCardDefaultVariants, ...compact(variants) })

export const shopCard = /* @__PURE__ */ Object.assign(shopCardFn, {
  __recipe__: false,
  __name__: 'shopCard',
  raw: (props) => props,
  variantKeys: shopCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, shopCardVariantKeys)
  },
  getVariantProps
})